import React from 'react'
import { colors } from '../../../../Components/consts'
import { contractEndDates } from '../../../../Config/config'
import { CustomSelect } from '../../../../Components/Layout'

type YearSelectProps = {
  current: string
  onChangeYear: (selector: string, year: string) => void
  color?: string
}

/**
 * Select year from allowed range
 */
export const EndYearSelect: React.FC<React.PropsWithChildren<YearSelectProps>> = ({
  current,
  onChangeYear,
  color = colors.yellow,
}) => {
  const value = current

  const onChange = (option: string) => {
    onChangeYear && onChangeYear('endYear', option)
  }


  return (
    <CustomSelect
      options={contractEndDates.map((yr) => yr.label)}
      value={value}
      onChange={onChange}
      id="end-year-select"
      ariaLabel="End year select"
    />
  )
}
